const FacebookIcon = ({ className, color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 0 46 46"
      className={className}
    >
      <path
        fill={color}
        d="M31.007 14H14.993a.993.993 0 00-.993.993v16.014c0 .549.445.993.993.993h8.62v-6.97h-2.346v-2.716h2.346v-2.006c0-2.325 1.421-3.59 3.495-3.59.994 0 1.848.073 2.097.107v2.43h-1.441c-1.125 0-1.344.54-1.344 1.328v1.733h2.688l-.349 2.723H26.42V32h4.586c.55 0 .994-.444.994-.993V14.993a.993.993 0 00-.993-.993z"
      ></path>
    </svg>
  );
};
export default FacebookIcon;
